import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['pay', 'hours', 'fte', 'actual', 'monthly', 'weekly', 'payd', 'paydw']

    connect() {
        this.calculateSummary()
    }

    calculateSummary() {

        this.fteTarget.innerHTML = (this.payTarget.value * 52 * 37.5).toLocaleString('en', {
            style: 'currency',
            currency: 'GBP'
        })
        this.actualTarget.innerHTML = (this.payTarget.value * 52 * this.hoursTarget.value).toLocaleString('en', {
            style: 'currency',
            currency: 'GBP'
        })
        this.monthlyTarget.innerHTML = (this.payTarget.value * 52 * this.hoursTarget.value / 12).toLocaleString('en', {
            style: 'currency',
            currency: 'GBP'
        })
        this.weeklyTarget.innerHTML = (this.payTarget.value * this.hoursTarget.value).toLocaleString('en', {
            style: 'currency',
            currency: 'GBP'
        })

        if (this.hasPaydTarget) {
            this.paydTarget.innerText = this.comparisonText(this.payTarget.value, this.element.dataset.avgPay)
            this.paydwTarget.innerText = this.comparisonText(
                this.payTarget.value * this.hoursTarget.value,
                this.element.dataset.avgWeeklyPay
            )
        }
    }

    comparisonText(value, average) {
        const numericValue = Number(value)
        const numericAverage = Number(average)
        if (!Number.isFinite(numericAverage) || numericAverage <= 0) return "not available"

        const difference = ((numericValue - numericAverage) / numericAverage) * 100
        if (Math.abs(difference) < 0.05) return "the same"

        return `${Math.abs(difference).toFixed(1)}% ${difference < 0 ? "lower" : "higher"}`
    }

}
